import React, { useState } from 'react';
import './CalculatorPage.css';

function SignatureNumerology() {
  const [signature, setSignature] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculate = (inputSignature) => {
    // Placeholder for Signature Numerology calculation logic
    if (!inputSignature) return null;
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < inputSignature.length; i++) {
      const char = inputSignature[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!signature) {
      setError('Please enter your signature.');
      return;
    }

    const calculated = calculate(signature);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Signature Numerology Number ${num}: This is a placeholder explanation for signature numerology number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Signature Numerology Calculator",
    "description": "Analyze your signature for numerological insights and its impact on your personality and destiny.",
    "url": "https://www.yourwebsite.com/signature-numerology",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Signature Numerology",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/signature-numerology?signature={signature}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=signature"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Signature Numerology</h1>
      <p className="text-center">Enter your signature to get a numerological analysis.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="signature">Enter Your Signature (as text):</label>
          <input
            type="text"
            id="signature"
            className="form-control"
            value={signature}
            onChange={(e) => setSignature(e.target.value)}
            placeholder="e.g., John Doe"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Signature</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Signature Numerology Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default SignatureNumerology;
